export function getStatsRatingsRoutes() {
  return [
    {
      path: "/stats/ratings",
      name: "stats-ratings",
      component: () => import(/* webpackChunkName: stats-ratings-old-backend */ "./components/StatsRatingsOld.vue"),
    },
  ]
}
